import { render, staticRenderFns } from "./ShareSection.vue?vue&type=template&id=ba4bd0e6"
import script from "./ShareSection.vue?vue&type=script&lang=js"
export * from "./ShareSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports